import { render } from "./AsNumbersTab.vue?vue&type=template&id=bd7cd52a&scoped=true"
import script from "./AsNumbersTab.vue?vue&type=script&lang=js"
export * from "./AsNumbersTab.vue?vue&type=script&lang=js"

import "./AsNumbersTab.vue?vue&type=style&index=0&id=bd7cd52a&scoped=true&lang=less"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd7cd52a"]])

export default __exports__